
import Vue from "vue";
import { SnackbarState } from "../";

export default Vue.extend({
  data() {
    return {
      state: SnackbarState,
    };
  },
});
